import { AsyncThunkAction } from "@reduxjs/toolkit";
import { Status } from "lib/enums";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "./store";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: <ReturnType>(selector: (state: RootState) => ReturnType) => ReturnType = useSelector;

export const useApiData = <ReturnType>(
  action: AsyncThunkAction<any, any, { rejectValue: any }>,
  dataSelector: (state: RootState) => ReturnType,
  statusSelector: (state: RootState) => Status,
  navigate: any
) => {
  const dispatch = useAppDispatch();
  const status = useAppSelector(statusSelector);
  const data = useAppSelector(dataSelector);

  useEffect(() => {
    if (status === Status.Idle || status === undefined) {
      const performAction = async () => {
        try {
          const result = await dispatch(action);

          if (result.meta.requestStatus === "rejected") {
            console.warn("API action was rejected on - ", result.type);
            navigate("/error-page"); 
          }
        } catch (error) {
          console.error("Error in useApiData:", error);
          navigate("/error-page"); 
        }
      };

      performAction();
    }
  }, [status, dispatch, action, navigate]);

  return data;
};